<template>
  <b-row class="mb-4">
    <b-col lg="3" sm="6">
      <statistic-card-horizontal
        :statistic="totalTranslations"
        statistic-title="Łączna liczba tłumaczeń"
        icon="FileTextIcon"
        color="primary" />
    </b-col>
    <b-col lg="3" sm="6">
      <statistic-card-horizontal
        :statistic="recentlyModified"
        statistic-title="Ostatnio zmodyfikowane"
        icon="EditIcon"
        color="success" />
    </b-col>
    <b-col lg="3" sm="6">
      <statistic-card-horizontal
        :statistic="missingTranslations"
        statistic-title="Brakujące tłumaczenia"
        icon="AlertTriangleIcon"
        color="warning" />
    </b-col>
    <b-col lg="3" sm="6">
      <statistic-card-horizontal
        :statistic="availableLocalesCount"
        statistic-title="Dostępne lokalizacje"
        icon="GlobeIcon"
        color="info" />
    </b-col>
  </b-row>
</template>

<script>
import StatisticCardHorizontal from '@/@core/components/statistics-cards/StatisticCardHorizontal.vue';

export default {
  name: 'TranslationsStats',
  components: {
    StatisticCardHorizontal,
  },
  props: {
    totalTranslations: {
      type: Number,
      default: 0,
    },
    recentlyModified: {
      type: Number,
      default: 0,
    },
    missingTranslations: {
      type: Number,
      default: 0,
    },
    availableLocalesCount: {
      type: Number,
      default: 0,
    },
  },
};
</script>